import { defineRouting } from 'next-intl/routing';
import { i18n } from '@/i18n/i18n';

export const routing = defineRouting(i18n);
